import React from 'react'
import { useNavigate } from 'react-router-dom';
import { IconButton, Tooltip, Button, Drawer, TextField } from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { profileModel } from '../Axios/AxiosConfig';
import usePrescriptionStore from '../DataRepository/Prescription';
import Loader from '../loading';
import AddIcon from "@mui/icons-material/Add";

function LifeStylePracticesSuggestions() {

    const navigate = useNavigate();

    const [Practices, setPractices] = useState([]);

    const {
        lifestylePractices,
        lifestylePracticesLoading,
        setyogalist,
        yogalist,
        pranayama,
        meditationList,
        setMeditationlist,
        setPranayamaList

    } = usePrescriptionStore();

    const [drawerOpen, setDrawerOpen] = useState(false);

    const [activeType, setActiveType] = useState(null);

    const handleDrawerOpen = (type) => {
        setActiveType(type);
        setDrawerOpen(true);
    };

    const handleDrawerClose = () => {
        setDrawerOpen(false);
        setActiveType(null);
    };

    const getlifestylePractices = async () => {
        try {
            let res = await profileModel.get("/getlifestylePractices");
            if (res.status === 200) {
                setPractices(res.data);

            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getlifestylePractices();
    }, []);

    const handleToggle = (type, item) => {
        const listMap = {
            yoga: yogalist,
            pranayama: pranayama,
            meditation: meditationList,
        };

        const setMap = {
            yoga: setyogalist,
            pranayama: setPranayamaList,
            meditation: setMeditationlist,
        };

        const listRaw = listMap[type];
        const setList = setMap[type];

        const list = Array.isArray(listRaw) ? listRaw : Object.values(listRaw || {});
        const itemId = String(type === "meditation" ? item.Id : item.id);
        const exists = list.find(i => String(type === "meditation" ? i.Id : i.id) === itemId);

        if (exists) {
            setList(list.filter(i => String(type === "meditation" ? i.Id : i.id) !== itemId));
        } else {
            setList([...list, { ...item }]);
        }
    };

    const handleFieldChange = (type, itemId, field, value) => {
        const listMap = {
            yoga: yogalist,
            pranayama: pranayama,
            meditation: meditationList,
        };

        const setMap = {
            yoga: setyogalist,
            pranayama: setPranayamaList,
            meditation: setMeditationlist,
        };

        const list = Array.isArray(listMap[type]) ? listMap[type] : Object.values(listMap[type] || {});
        const setList = setMap[type];

        const updated = list.map(item => {
            const currentId = String(type === "meditation" ? item.Id : item.id);
            if (currentId === String(itemId)) {
                return { ...item, [field]: value };
            }
            return item;
        });

        setList(updated);
    };

    const renderItems = (type, displayList, selectedListRaw, inputField) => {

        const selectedList = Array.isArray(selectedListRaw) ? selectedListRaw : Object.values(selectedListRaw || {});

        const selectedIds = selectedList.map(p => String(p.Id || p.id));

        return (
            <div className="flex flex-wrap items-stretch gap-2 mt-2">
                {displayList.map(item => {
                    const itemId = String(item.Id || item.id);
                    const isSelected = selectedIds.includes(itemId);
                    const selectedItem = selectedList.find(p => String(p.Id || p.id) === itemId) || {};

                    return (
                        <Tooltip
                            key={itemId}
                            title={
                                <div className="p-1">
                                    {(item.disease_benefit || item.mental_benefit) && (
                                        <p className="mb-1"><strong>Benefit:</strong> {item.disease_benefit || item.mental_benefit}</p>
                                    )}
                                    {item.dosha_balanced && (
                                        <p className="mb-1"><strong>Balanced:</strong> {item.dosha_balanced}</p>
                                    )}
                                    {item.intensity && (
                                        <p className="mb-1"><strong>Intensity:</strong> {item.intensity}</p>
                                    )}
                                    {item.safety_note && (
                                        <p className="mb-1"><strong>Safety:</strong> {item.safety_note}</p>
                                    )}
                                    {/* Fallback for static practices */}
                                    {!item.disease_benefit && !item.mental_benefit && item.reason && (
                                        <p className="mb-1"><strong>Reason:</strong> {item.reason}</p>
                                    )}
                                    {!item.dosha_balanced && item.doshaTargeted && (
                                        <p className="mb-0"><strong>Dosha:</strong> {item.doshaTargeted}</p>
                                    )}
                                </div>
                            }
                            arrow
                        >
                            <div className="food-item relative">
                                <div className="food-item-img-container mb-2" onClick={() => handleToggle(type, item)}>
                                    <img src={item.image} alt={item.title} className="food-image" />
                                    <input type="checkbox" checked={isSelected} readOnly className="overlay-checkbox" />
                                </div>
                                <p className="mt-2 w-full" style={{ width: "10rem" }}>{item.title || item.pose}</p>
                                {isSelected && (
                                    <TextField
                                        size="small"
                                        type="number"
                                        value={selectedItem?.[inputField] || ""}
                                        label={inputField === "duration" ? "Minutes" : "Reps"}
                                        onChange={(e) => handleFieldChange(type, itemId, inputField, e.target.value)}
                                        style={{ width: "90px", marginTop: "6px" }}
                                    />
                                )}
                            </div>
                        </Tooltip>
                    );
                })}
            </div>
        );
    };

    return <div className='All-products-section-main'>

        <nav className='flex flex-row p-2 items-center justify-between' style={{ backgroundColor: "var(--themeSecondaryColor, #f4ecd6)" }}>
            <div className='flex flex-row items-center'>
                <IconButton onClick={() => navigate(-1)}>
                    <ChevronLeft />
                </IconButton>
                <p className='mb-0' style={{
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: 500,
                }}>Lifestyle Practices Suggestions</p>
            </div>
        </nav>

        <div>
            {lifestylePracticesLoading ? (
                <Loader loading={lifestylePracticesLoading} />
            ) : (
                <div className="flex flex-col gap-4 p-4 rounded-lg">
                    {["Yoga", "Pranayama", "Meditation"].map((practiceType) => {

                        const fullList = Practices?.[practiceType.toLowerCase()] || [];

                        const recommendedList = lifestylePractices?.[practiceType] || [];

                        const selectedMap = {
                            Yoga: yogalist,
                            Pranayama: pranayama,
                            Meditation: meditationList
                        };

                        const setMap = {
                            Yoga: setyogalist,
                            Pranayama: setPranayamaList,
                            Meditation: setMeditationlist
                        };

                        const inputField = practiceType === "Meditation" ? "duration" : "reps";

                        const selected = selectedMap[practiceType];

                        return (
                            <div key={practiceType} className="p-5 flex flex-col gap-4 w-full">
                                <div className="flex flex-row justify-between items-center px-2" style={{ borderLeft: "5px solid var(--themePrimaryColor, #DA6E0B)", borderRadius: "8px" }}>
                                    <p className="text-lg font-medium">{practiceType}</p>
                                    <IconButton onClick={() => handleDrawerOpen(practiceType)}>
                                        <AddIcon />
                                    </IconButton>
                                </div>
                                {renderItems(practiceType.toLowerCase(), recommendedList, selected, inputField)}
                            </div>
                        );
                    })}
                </div>
            )}

            <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerClose}>
                <div className="p-4 w-[420px] flex flex-col gap-3">
                    <p className="text-lg font-semibold">{activeType} – Add More</p>
                    {activeType && renderItems(
                        activeType.toLowerCase(),
                        Practices?.[activeType.toLowerCase()] || [],
                        {
                            yoga: yogalist,
                            pranayama: pranayama,
                            meditation: meditationList
                        }[activeType.toLowerCase()],
                        activeType === "Meditation" ? "duration" : "reps"
                    )}
                </div>
            </Drawer>
        </div>

        <div className='m-5' style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
                style={{
                    textTransform: "none",
                    backgroundColor: "var(--themePrimaryColor, #DA6E0B)",
                    color: "white",
                    border: "none",
                    boxSizing: "border-box",
                    borderRadius: "5px",
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: 500,
                    padding: "10px",
                }}
                onClick={() => {
                    navigate(-1);
                }}
            >
                Save and Proceed
            </Button>
        </div>


    </div>
}

export default LifeStylePracticesSuggestions